import Vue from 'vue'
import Router from 'vue-router'

import Welcome from '@/pages/Welcome'
import Warning from '@/pages/Warning'
import Reg from '@/pages/Reg'
import LogIn from '@/pages/newLogIn'
import Protocol from '@/pages/Protocol'
import Regulation from '@/pages/Regulation'
import Map from '@/pages/Map'

// import Calendar from '@/pages/calendar/Calendar'

// import Gallery from '@/pages/gallery/Gallery'
// import GalleryDetail from '@/pages/gallery/Detail'

// import CityGuide from '@/pages/city_guide/CityGuide'
// import Clubs from '@/pages/city_guide/Clubs'
// import Ambassador from '@/pages/ambassador/Ambassador'
// import AmbassadorDetail from '@/pages/ambassador/Detail'

// import Funding from '@/pages/funding/Funding'
// import Explore from '@/pages/funding/Explore'
// import Creation from '@/pages/funding/Creation'
// import Submissions from '@/pages/funding/Submissions'
// import MoreTips from '@/pages/funding/MoreTips'
// import ProjectDetail from '@/pages/funding/project/Detail'
// import CreationStep1 from '@/pages/funding/creation/Step1'
// import CreationStep2 from '@/pages/funding/creation/Step2'
// import CreationStep3 from '@/pages/funding/creation/Step3'
// import CreationStep4 from '@/pages/funding/creation/Step4'
// import CreationStep5 from '@/pages/funding/creation/Step5'
// import CreationPreview from '@/pages/funding/creation/Preview'

// import Announcement from '@/pages/announcement/Announcement'
// import AnnouncementExplore from '@/pages/announcement/Explore'
// import AnnouncementBottles from '@/pages/announcement/Bottles'
// import AnnouncementProjectDetail from '@/pages/announcement/project/Detail'

// import Location from '@/pages/location/Location'

// import Events from '@/pages/events/Events'
// import EventDetail from '@/pages/events/Detail'
// import GroupQr from '@/pages/events/GroupQr'

// import VideoPage from '@/pages/VideoPage'

// import RebuildLanding from '@/pages/rebuild/Landing'
// import RebuildIntroduction from '@/pages/rebuild/Introduction'
// import RebuildJury from '@/pages/rebuild/Jury'
// import RebuildMine from '@/pages/rebuild/Mine'
// import RebuildSubmissions from '@/pages/rebuild/Submissions'
// import RebuildCreation from '@/pages/rebuild/Creation/Creation'
// import RebuildCreation100 from '@/pages/rebuild/Creation/Creation100'
// import RebuildPreview from '@/pages/rebuild/Creation/Preview'
// import RebuildPreview100 from '@/pages/rebuild/Creation/Preview100'
// import RebuildProject from '@/pages/rebuild/Project/Detail'
// import RebuildProjectPreview from '@/pages/rebuild/Project/Preview'
// import RebuildRules from '@/pages/rebuild/Rules'
// import ShowRoom from '@/pages/Showroom'

import ugc from './ugc'
import fundingnew from './fundingnew'

Vue.use(Router)

export default new Router({
  mode: 'history',
  // base: '/new/',
  routes: [
    {
      path: '/',
      redirect: '/welcome',
      name: 'Home',
      meta: {
        title: '绝对夜计划',
        auth: false,
      },
    },
    {
      path: '/welcome',
      name: 'Welcome',
      component: Welcome,
      meta: {
        title: '绝对夜计划',
        auth: false,
      },
    },
    {
      path: '/warning',
      name: 'Warning',
      component: Warning,
      meta: {
        title: '全新绝对夜计划',
        auth: false,
      },
    },
    {
      path: '/reg',
      name: 'Reg',
      component: Reg,
      meta: {
        title: '注册',
        auth: false,
      },
    },
    {
      path: '/login',
      name: 'LogIn',
      component: LogIn,
      meta: {
        title: '登录',
        auth: false,
      },
    },
    {
      path: '/protocol',
      name: 'Protocol',
      component: Protocol,
      meta: {
        title: '隐私条款',
        auth: false,
      },
    },
    {
      path: '/regulation',
      name: 'Regulation',
      component: Regulation,
      meta: {
        title: '使用条款',
        auth: false,
      },
    },
    {
      path: '/map',
      name: 'Map',
      component: Map,
      meta: {
        title: '查看位置',
        auth: false,
      },
    },
    // {
    //   path: '/calendar',
    //   name: 'Calendar',
    //   component: Calendar,
    //   meta: {
    //     title: '活动日历',
    //     auth: false,
    //   },
    // },
    // {
    //   path: '/gallery',
    //   name: 'Gallery',
    //   component: Gallery,
    //   meta: {
    //     title: '绝对瞬间',
    //     auth: false,
    //   },
    // },
    // {
    //   path: '/gallery/:id',
    //   name: 'GalleryDetail',
    //   component: GalleryDetail,
    //   meta: {
    //     title: '绝对瞬间',
    //     auth: false,
    //   },
    // },
    // {
    //   path: '/city_guide',
    //   name: 'CityGuide',
    //   component: CityGuide,
    //   meta: {
    //     title: '城市夜行指南',
    //     auth: false,
    //   },
    // },
    // {
    //   path: '/city_guide/clubs/:id',
    //   name: 'Clubs',
    //   component: Clubs,
    //   meta: {
    //     title: '俱乐部',
    //     auth: false,
    //   },
    // },
    // {
    //   path: '/ambassador',
    //   name: 'Ambassador',
    //   component: Ambassador,
    //   meta: {
    //     title: '品牌大使',
    //     auth: false,
    //   },
    // },
    // {
    //   path: '/ambassador/:id',
    //   name: 'AmbassadorDetail',
    //   component: AmbassadorDetail,
    //   meta: {
    //     title: '品牌大使',
    //     auth: false,
    //   },
    // },
    // {
    //   path: '/funding',
    //   name: 'Funding',
    //   component: Funding,
    //   meta: {
    //     title: '夜计划悬赏',
    //     auth: false,
    //   },
    // },
    // {
    //   path: '/funding/explore',
    //   name: 'Explore',
    //   component: Explore,
    //   meta: {
    //     title: '夜计划悬赏',
    //     auth: false,
    //   },
    // },
    // {
    //   path: '/funding/creation',
    //   name: 'Creation',
    //   component: Creation,
    //   meta: {
    //     title: '评审开小灶',
    //     auth: false,
    //   },
    // },
    // {
    //   //path: '/funding/submissions',
    //   path: '/submissions',
    //   name: 'Submissions',
    //   component: Submissions,
    //   meta: {
    //     title: '看我的',
    //     auth: true,
    //   },
    // },
    // {
    //   path: '/funding/more_tips',
    //   name: 'MoreTips',
    //   component: MoreTips,
    //   meta: {
    //     title: '评判与贴士',
    //     auth: false,
    //   },
    // },
    // {
    //   path: '/funding/project/:id',
    //   name: 'ProjectDetail',
    //   component: ProjectDetail,
    //   meta: {
    //     title: '详情',
    //     auth: false,
    //   },
    // },
    // {
    //   path: '/funding/creation/step1',
    //   name: 'CreationStep1',
    //   component: CreationStep1,
    //   meta: {
    //     title: '造一个',
    //     keepAlive: true,
    //     auth: true,
    //   },
    // },
    // {
    //   path: '/funding/creation/step2',
    //   name: 'CreationStep2',
    //   component: CreationStep2,
    //   meta: {
    //     title: '造一个',
    //     keepAlive: true,
    //     auth: true,
    //   },
    // },
    // {
    //   path: '/funding/creation/step3',
    //   name: 'CreationStep3',
    //   component: CreationStep3,
    //   meta: {
    //     title: '造一个',
    //     keepAlive: true,
    //     auth: true,
    //   },
    // },
    // {
    //   path: '/funding/creation/step4',
    //   name: 'CreationStep4',
    //   component: CreationStep4,
    //   meta: {
    //     title: '造一个',
    //     keepAlive: true,
    //     auth: true,
    //   },
    // },
    // {
    //   path: '/funding/creation/step5',
    //   name: 'CreationStep5',
    //   component: CreationStep5,
    //   meta: {
    //     title: '造一个',
    //     keepAlive: true,
    //     auth: true,
    //   },
    // },
    // {
    //   path: '/funding/creation/preview',
    //   name: 'CreationPreview',
    //   component: CreationPreview,
    //   meta: {
    //     title: '造一个',
    //     keepAlive: true,
    //     auth: true,
    //   },
    // },
    // {
    //   path: '/announcement',
    //   name: 'Announcement',
    //   component: Announcement,
    //   meta: {
    //     title: '绝对夜计划',
    //     auth: false,
    //   },
    // },
    // {
    //   path: '/announcement/explore',
    //   name: 'AnnouncementExplore',
    //   component: AnnouncementExplore,
    //   meta: {
    //     title: '绝对夜计划回顾',
    //     auth: false,
    //   },
    // },
    // {
    //   path: '/announcement/bottles',
    //   name: 'AnnouncementBottles',
    //   component: AnnouncementBottles,
    //   meta: {
    //     title: '城市态度瓶',
    //     auth: false,
    //   },
    // },
    // {
    //   path: '/announcement/project/:id',
    //   name: 'AnnouncementProjectDetail',
    //   component: AnnouncementProjectDetail,
    //   meta: {
    //     title: '详情',
    //     auth: false,
    //   },
    // },
    // {
    //   path: '/location',
    //   name: 'Location',
    //   component: Location,
    //   meta: {
    //     title: '选择城市',
    //     auth: false,
    //   },
    // },
    // {
    //   path: '/events',
    //   name: 'Events',
    //   component: Events,
    //   meta: {
    //     title: '派对预告',
    //     auth: false,
    //   },
    // },
    // {
    //   path: '/events/:id',
    //   name: 'EventDetail',
    //   component: EventDetail,
    //   meta: {
    //     title: '活动详情',
    //     auth: false,
    //   },
    // },
    // {
    //   path: '/events/:id/groupqr',
    //   name: 'GroupQr',
    //   component: GroupQr,
    //   meta: {
    //     title: '群二维码',
    //     auth: false,
    //   },
    // },
    // {
    //   path: '/video_page',
    //   name: 'VideoPage',
    //   component: VideoPage,
    //   meta: {
    //     title: '火星之旅',
    //     auth: false,
    //   },
    // },
    // {
    //   path: '/reinvent',
    //   name: 'RebuildLanding',
    //   component: RebuildLanding,
    //   meta: {
    //     title: '百城绝对重造计划',
    //     auth: false,
    //   },
    // },
    // {
    //   path: '/reinvent_introduction',
    //   name: 'RebuildIntroduction',
    //   component: RebuildIntroduction,
    //   meta: {
    //     title: '百城绝对重造计划',
    //     auth: false,
    //   },
    // },
    // {
    //   path: '/reinvent_jury',
    //   name: 'RebuildJury',
    //   component: RebuildJury,
    //   meta: {
    //     title: '百城绝对重造计划',
    //     auth: false,
    //   },
    // },
    // {
    //   path: '/reinvent_mine',
    //   name: 'RebuildMine',
    //   component: RebuildMine,
    //   meta: {
    //     title: '百城绝对重造计划',
    //     auth: true,
    //   },
    // },
    // {
    //   path: '/reinvent_submissions',
    //   name: 'RebuildSubmissions',
    //   component: RebuildSubmissions,
    //   meta: {
    //     title: '百城绝对重造计划',
    //     auth: false,
    //   },
    // },
    // {
    //   path: '/reinvent_creation',
    //   name: 'RebuildCreation',
    //   component: RebuildCreation,
    //   meta: {
    //     title: '百城绝对重造计划',
    //     keepAlive: true,
    //     auth: true,
    //   },
    // },
    // {
    //   path: '/reinvent_creation100',
    //   name: 'RebuildCreation100',
    //   component: RebuildCreation100,
    //   meta: {
    //     title: '百城绝对重造计划',
    //     keepAlive: true,
    //     auth: true,
    //   },
    // },
    // {
    //   path: '/reinvent_preview',
    //   name: 'RebuildPreview',
    //   component: RebuildPreview,
    //   meta: {
    //     title: '百城绝对重造计划',
    //     auth: true,
    //   },
    // },
    // {
    //   path: '/reinvent_preview100',
    //   name: 'RebuildPreview100',
    //   component: RebuildPreview100,
    //   meta: {
    //     title: '百城绝对重造计划',
    //     auth: true,
    //   },
    // },
    // {
    //   path: '/reinvent_project/:id',
    //   name: 'RebuildProject',
    //   component: RebuildProject,
    //   meta: {
    //     title: '百城绝对重造计划',
    //     auth: false,
    //   },
    // },
    // {
    //   path: '/reinvent_project_preview/:id',
    //   name: 'RebuildProjectPreview',
    //   component: RebuildProjectPreview,
    //   meta: {
    //     title: '百城绝对重造计划',
    //     auth: true,
    //   },
    // },
    // {
    //   path: '/reinvent_rules',
    //   name: 'RebuildRules',
    //   component: RebuildRules,
    //   meta: {
    //     title: '百城绝对重造计划',
    //     auth: false,
    //   },
    // },
    // {
    //   path: '/show_room',
    //   name: 'ShowRoom',
    //   component: ShowRoom,
    //   meta: {
    //     title: '潮流主理人',
    //     auth: false,
    //   },
    // },
    ...ugc,
    ...fundingnew,
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
})



// WEBPACK FOOTER //
// ./src/router/index.js